import {ListView} from '@github-ui/list-view'
import {ListViewMetadata} from '@github-ui/list-view/ListViewMetadata'
import {SkeletonBox} from '@primer/react/experimental'

import styles from './SharedListLoadingSkeleton.module.css'
import {dashboardTypeLabels, type DashboardTypes} from '@github-ui/shared-dashboard-sidebar/types/dashboard-types'

export function SharedListLoadingSkeleton({
  dashboardType,
  numItems,
}: {
  dashboardType: DashboardTypes
  numItems: number
}) {
  const title = (
    <>
      <span className="sr-only">Loading {dashboardTypeLabels[dashboardType]}</span>
      <SkeletonBox width="80px" height="20px" />
    </>
  )

  const metadata = (
    <ListViewMetadata title={title}>
      <SkeletonBox width="120px" height="32px" />
    </ListViewMetadata>
  )

  return (
    <div className="tmp-my-3">
      <div className={styles.listContainer}>
        <ListView metadata={metadata} title={`Loading ${dashboardTypeLabels[dashboardType]}`} titleHeaderTag="h2">
          {Array.from({length: numItems}).map((_, i) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key -- static skeleton items never reorder
            <li key={`skeleton-item-${i}`}>
              <div className={styles.skeletonItem}>
                <div className={styles.skeletonHeader}>
                  <SkeletonBox width="20px" height="20px" />
                  <SkeletonBox width="60%" height="20px" />
                </div>
                <div className={styles.skeletonDescription}>
                  <SkeletonBox width="80%" height="16px" />
                </div>
                <div className={styles.skeletonMetadata}>
                  <SkeletonBox width="80px" height="16px" />
                  <SkeletonBox width="80px" height="16px" />
                  <SkeletonBox width="80px" height="16px" />
                </div>
              </div>
            </li>
          ))}
        </ListView>
      </div>
    </div>
  )
}
